import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  categories: [],
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    removeCategories: (state) => {
      state.categories = [];
    },
  },
});

export default categoriesSlice;

export const { setCategories, removeCategories } = categoriesSlice.actions;
